module.exports = __webpack_public_path__ + "img/solution-ethernet-function-pic.bfbb5853.png";